//import '../css/style.scss';

// Our modules / classes
//import MyNotes from './modules/MyNotes';
import HaNotes from './modules/HaNotes';
import HaBikes from './modules/HaBikes';
// Instantiate a new object using our modules/classes
//const myNotes = new MyNotes();
const haNotes = new HaNotes();
const haBikes = new HaBikes();
//Test
